import React from 'react';
import { Box } from 'theme-ui';

type Props = { height?: number };

// MapSkeleton: match the DonutCardSkeleton visual style (solid grey shapes + pulse)
const MapSkeleton: React.FC<Props> = ({ height = 320 }) => {
    const circleSize = Math.round(height * 0.5);
    return (
        <Box sx={{ width: '100%' }}>
            <style>{`
                @keyframes ec-chart-skeleton-pulse { 0% { opacity: 0.8 } 50% { opacity: 1 } 100% { opacity: 0.6 } }
                .map-skel-card { width: 100%; height: ${height}px; padding: 20px; background: #ffffff; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); display: flex; gap: 20px; animation: ec-chart-skeleton-pulse 1.5s infinite ease-in-out; }
                .map-skel-donut { position: relative; width: ${circleSize}px; height: ${circleSize}px; border-radius: 50%; background: #e9e9e9; display:flex; align-items:center; justify-content:center; }
                .map-skel-center { width: ${Math.round(circleSize * 0.75)}px; height: ${Math.round(circleSize * 0.75)}px; border-radius: 50%; background: #ffffff; border: ${Math.round(circleSize * 0.08)}px solid #e9e9e9; }
                .map-skel-lines { flex: 1; display: flex; flex-direction: column; justify-content: flex-start; gap: 12px; padding-top: 12px; }
                .map-skel-line { height: 14px; background: #e6e6e6; border-radius: 12px; }
                .map-skel-line.short { width: 40%; }
                .map-skel-line.mid { width: 70%; }
                .map-skel-line.long { width: 95%; }
                .map-skel-bottom { margin-top: auto; display:flex; gap: 10px; align-items:center; }
                .map-skel-legend-dot { width: 12px; height: 12px; border-radius: 2px; background: #e6e6e6; }
                .map-skel-legend-label { width: 60px; height: 10px; border-radius: 6px; background: #e6e6e6; }
            `}</style>

            <div className="map-skel-card">
                <div className="map-skel-donut">
                    <div className="map-skel-center" />
                </div>

                <div className="map-skel-lines">
                    <div className="map-skel-line long" />
                    <div className="map-skel-line mid" />
                    <div className="map-skel-line long" />
                    <div className="map-skel-line short" />
                    <div className="map-skel-line long" />
                    <div className="map-skel-line mid" />
                </div>
            </div>
        </Box>
    );
};

export default React.memo(MapSkeleton);
